const extractVideoId = (url) => {
  if (url.includes("youtube.com") || url.includes("youtu.be")) {
    // Extract YouTube video ID
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=)|youtu\.be\/)([^&\n\/]{11})/;
    const match = url.match(regex);
    return match ? match[1] : ""; // Extract the matched video ID
  } else {
    // Regular expression to match numbers at the end of the string
    const regex = /([a-zA-Z0-9\-]+)$/;
    const match = url.match(regex);
    return match ? match[0] : ""; // Extract the matched number
  }
};

export default extractVideoId;
